import React from "react";

import Box from "../Box";
import Stack from "../Stack";
import Typography from "../Typography";

import { UIError } from "digiwash-core/types";

interface PropTypes extends UIError {
  // Potential props
  // recoverable: () => void
  // dismissable
  // autoDismiss
}

function MessageBox(props: PropTypes) {
  if (!props.title && !props.body) return null;
  let colors = {
    bg: "yellow.main",
    text: "common.black",
  };

  return (
    <Box bg={colors.bg} p="m" br="m">
      <Stack distribution="center" direction="vertical">
        {props.title ? (
          <Typography ff="mainBold" color={colors.text}>
            {props.title}
          </Typography>
        ) : null}
        {props.body ? (
          <Typography color={colors.text}>{props.body}</Typography>
        ) : null}
      </Stack>
    </Box>
  );
}

MessageBox.defaultProps = {
  type: "warning",
};

export default MessageBox;
